import React from 'react';
import PropTypes from 'prop-types';
import ShareLink from 'chameleon/ui-stack/ui/base/share-link';

/**
 * Component used to share the link of a resource or assignment with students outside AP Classroom.
 * */
const DisabledInputShareLink = (props) => {
  const {
    className,
    header,
    link,
    timeout,
    onCopy,
    notificationText,
    tooltip,
  } = props;

  return (
    <div className={className}>
      <div className="text-14 font-medium text-gray-900 mb-0.8">{header}</div>
      <div className="border flex-row items-center justify-between px-4.2 py-2.8 rounded-24.8 bg-gray-200">
        <div className="flex-1">
          <input
            className="w-full text-14 text-gray-900 bg-none"
            disabled
            value={link}
          />
        </div>
        <ShareLink
          text={link}
          onCopy={onCopy}
          options={{ format: 'text/plain' }}
          timeout={timeout}
          notificationText={notificationText}
          tooltip={tooltip}
        >
          <div
            className="ml-4.2 text-14 text-blue-700 cursor-pointer"
            role="button"
            tabIndex={0}
            aria-label="Copy URL to clipboard."
          >
            Copy
          </div>
        </ShareLink>
      </div>
    </div>
  );
};

DisabledInputShareLink.displayName = 'ShareLink';

DisabledInputShareLink.propTypes = {
  // Custom class for styling component from parent.
  className: PropTypes.string,
  // Header to inform user what's the purpose of the link.
  header: PropTypes.string.isRequired,
  // Link to be shared.
  link: PropTypes.string.isRequired,
  // Time to show the notification.
  timeout: PropTypes.number,
  // Callback for copy action
  onCopy: PropTypes.func,
  // Text to be used in toast notification.
  notificationText: PropTypes.string,
  // Tooltip information for copy CTA.
  tooltip: PropTypes.object,
};

DisabledInputShareLink.defaultProps = {
  className: null,
  timeout: undefined,
  onCopy: null,
  notificationText: undefined,
  tooltip: null,
};

export default DisabledInputShareLink;
